module.exports = __webpack_public_path__ + "static/hunter-douglas-alustra-collection-419ae620fa3fdf2ad166c48ee77e409d.png";